import { createSlice } from '@reduxjs/toolkit';
import { SLICES } from '../../constants/slices';

const paymentSlice = createSlice({
  name: SLICES.PAYMENT,
  initialState: {
    validatedOustandingDetailsList: [],
    instalmentToPayList: {},
    paymentResponseObj: {}
  },
  reducers: {
    setValidatedOustandingDetailsList: (state, action) => {
      const { updatedTransactionsData } = action.payload;
      state.validatedOustandingDetailsList = {
        updatedTransactionsData
      };
    },
    clearValidatedOustandingDetailsList: (state) => {
      state.validatedOustandingDetailsList = []; // Clear the list
    },
    setInstalmentToPay: (state, action) => {
      const { activeStep, transaction } = action.payload;
      state.instalmentToPayList = {
        activeStep,
        transaction
      };
    },
    clearInstalmentToPay: (state) => {
      state.instalmentToPayList = []; // Clear the list
    },
    setPaymentResponse: (state, action) => {
      const { totalAmountPaid, activeStep, payment } = action.payload;
      state.paymentResponseObj = {
        activeStep,
        payment,
        totalAmountPaid
      };
    },
    clearPaymentResponse: (state) => {
      state.paymentResponseObj = {};
    }
  }
});

export const {
  setValidatedOustandingDetailsList,
  clearValidatedOustandingDetailsList,
  setInstalmentToPay,
  clearInstalmentToPay,
  setPaymentResponse,
  clearPaymentResponse
} = paymentSlice.actions;

export default paymentSlice.reducer;
